import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Deserializer } from 'jsonapi-serializer';

import Employees from 'api/resources/employees';
import getErrors from 'utils/getErrors';

import Logo from 'icons/Logo';
import ButtonLoader from 'components/Loader/ButtonLoader';

import AuthError from './AuthError';
import Container from './Container';
import Wrapper from './Wrapper';
import GoogleLoginStyled from './GoogleLoginStyled';

const CLIENT_ID = '860784278097-2s82fmfdepp2vnmsmskn3i2tgdlgbp84.apps.googleusercontent.com';

export class LoginPage extends React.PureComponent {
  state = { loading: false, errors: [] };

  handleGoogleLoginSuccess = async (googleResponse) => {
    this.setState({ loading: true, errors: [] });

    try {
      const response = await Employees.post({
        body: { token_id: googleResponse.tokenId },
        include: 'avatar',
      });
      const employee = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({ loading: false });

      if (employee) this.props.onLoginSuccess(employee);
    } catch (err) {
      const errors = await getErrors(err);
      this.setState({ loading: false, errors });
    }
  }

  handleGoogleLoginError = (error) => {
    this.setState({ errors: [error.details] });
  }

  render() {
    return (
      <Container>
        <Helmet>
          <title>Вход</title>
        </Helmet>

        <Wrapper>
          <div style={{ marginBottom: '44px' }}>
            <Logo size="151" />
          </div>

          {this.state.loading
            ? <ButtonLoader />
            : (
              <GoogleLoginStyled
                icon={false}
                clientId={CLIENT_ID}
                buttonText="Войти через Google"
                onSuccess={this.handleGoogleLoginSuccess}
                onFailure={this.handleGoogleLoginError}
              />
            )
          }

          {this.state.errors.map(message => (
            <AuthError key={message} role="alert">
              {message || 'Что-то пошло не так, проверьте подключение к Интернету'}
            </AuthError>
          ))}
        </Wrapper>
      </Container>
    );
  }
}

LoginPage.propTypes = {
  onLoginSuccess: PropTypes.func,
};

LoginPage.defaultProps = {
  onLoginSuccess: () => {},
};

export default LoginPage;
